import {SharedModule} from 'src/app/shared/shared.module';
import {NotFoundComponent} from './components';

export const COMPONENTS = [
  NotFoundComponent
];

export const IMPORTS = [
  SharedModule
];

export const SERVICES = [];

export const EXPORTS = [];
